<template>
  <div v-if="experience" class="border-b-[0.5px] border-beige3 first:pt-0 last:border-b-0">
    <NuxtLink class="block pb-4 pt-4" :to="`/experiences/${experience.slug}/`">
      <div class="flex flex-col md:flex-row" data-testid="medium-experience-card">
        <ExperienceCarousel class="h-full min-h-[250px] min-w-full max-w-[368px] object-cover md:max-h-[250px] md:min-w-[368px]" :disable-carousel-on-sp="false" :images="experience.images" />
        <div class="w-full md:ml-4 md:flex md:w-1/2 md:flex-col md:justify-center">
          <ExperienceCardContent :experience="experience" :theme="props.theme" />
          <div v-if="microCMSExperience.overviewV2" class="my-2 line-clamp-3 w-full px-1 text-sm text-gray4 md:my-4 md:text-base" v-html="microCMSExperience.overviewV2"></div>
          <div class="flex items-center justify-end px-1">
            <p class="text-gold3">View More</p>
            <img alt="" class="h-6 w-6" src="@/wabunka-src/common/assets/svg/chevron_forward.svg" />
          </div>
        </div>
      </div>
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
import type { ExperienceViewModel, MicroCMSExperienceViewModel } from '@/wabunka-src/features/Experience';
import { ExperienceCarousel, ExperienceCardContent } from '@/wabunka-src/features/Experience';

const props = defineProps<{
  microCMSExperience: MicroCMSExperienceViewModel;
  experience: ExperienceViewModel | undefined;
  theme: 'light' | 'dark';
}>();
</script>
